import { Outlet } from "@tanstack/react-router";
import { LoadingOverlay } from "components/layout/LoadingOverlay";
import { Suspense } from "react";

export const EventsLayout = () => {
    return (
        <Suspense fallback={<LoadingOverlay />}>
            <Outlet />
        </Suspense>
    );
};
